import React from "react";
import PrivacyPolicy from "../../components/PrivacyPolicy/PrivacyPolicy";

const Privacy = () => {
    return (
        <div className="privacy-container">
            <div>
                <PrivacyPolicy />
            </div>
        </div>
    );
};

export default Privacy;
